import {
  ORDER_TEMPLATE_GET_LIST,
  ORDER_TEMPLATE_GET,
  ORDER_TEMPLATE_CREATE,
  ORDER_TEMPLATE_UPDATE,
  ORDER_TEMPLATE_DEACTIVATE,
  ORDER_TEMPLATE_REQUEST,
  ORDER_TEMPLATE_SUCCESS,
  ORDER_TEMPLATE_ERROR,
  VENDOR_GET_LIST,
  VENDOR_REQUEST,
  VENDOR_SUCCESS,
  VENDOR_ERROR,
  CLIENT_USER_GET_LIST,
  CLIENT_USER_REQUEST,
  CLIENT_USER_SUCCESS,
  CLIENT_USER_ERROR,
} from '@/store/types'

import axios from '@/store/axios'

const state = {
  list: null,
  current: null,
  clientUsers: null,
  vendors: null,
  isLoading: false,
  error: null,
}

const getters = {
  getOrderTemplateList: (state) => state.list,
  getCurrentOrderTemplate: (state) => state.current,
  getClientUsers: (state) => state.clientUsers,
  getVendors: (state) => state.vendors,
  isOrderTemplateLoading: (state) => state.isLoading,
  getOrderTemplateError: (state) => state.error,
}

const actions = {
  [ORDER_TEMPLATE_GET_LIST]: ({ commit }, { clientUser, clientUserName } = {}) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_TEMPLATE_REQUEST)

      let query = ''
      if (clientUser !== undefined) {
        query = `?client_user=${clientUser}`
      } else if (clientUserName !== undefined) {
        query = `?client_user_name=${clientUserName}`
      }
      axios
        .get(`/api/v1a/order_templates/${query}`)
        .then((resp) => {
          commit(ORDER_TEMPLATE_SUCCESS, { list: resp.data.results })
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [ORDER_TEMPLATE_GET]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_TEMPLATE_REQUEST)

      axios
        .get(`/api/v1a/order_templates/${id}/`)
        .then((resp) => {
          commit(ORDER_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [ORDER_TEMPLATE_CREATE]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_TEMPLATE_REQUEST)

      axios
        .post('/api/v1a/order_templates/', data)
        .then((resp) => {
          commit(ORDER_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [ORDER_TEMPLATE_UPDATE]: ({ commit }, { id, data }) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_TEMPLATE_REQUEST)

      axios
        .patch(`/api/v1a/order_templates/${id}/`, data)
        .then((resp) => {
          commit(ORDER_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [ORDER_TEMPLATE_DEACTIVATE]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_TEMPLATE_REQUEST)

      axios
        .patch(`/api/v1a/order_templates/${id}/`, { is_active: false })
        .then((resp) => {
          commit(ORDER_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [VENDOR_GET_LIST]: ({ commit }, { clientUser } = {}) => {
    return new Promise((resolve, reject) => {
      commit(VENDOR_REQUEST)

      const query = clientUser !== undefined ? `?client_user=${clientUser}` : ''
      axios
        .get(`/api/v1a/vendors/${query}`)
        .then((resp) => {
          commit(VENDOR_SUCCESS, { vendors: resp.data.results })
          resolve(resp)
        })
        .catch((err) => {
          commit(VENDOR_ERROR, err)
          reject(err)
        })
    })
  },
  [CLIENT_USER_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(CLIENT_USER_REQUEST)

      const accumulate = (url, acc) =>
        axios.get(url).then((resp) => {
          acc.push(...resp.data.results)
          return resp.data.next ? accumulate(resp.data.next, acc) : acc
        })

      accumulate('/api/v1a/client_users/?page_size=100', [])
        .then((clientUsers) => {
          commit(CLIENT_USER_SUCCESS, { clientUsers })
          resolve(clientUsers)
        })
        .catch((err) => {
          commit(CLIENT_USER_ERROR, err)
          reject(err)
        })
    })
  },
}

const mutations = {
  [ORDER_TEMPLATE_REQUEST]: (state) => {
    state.isLoading = true
    state.error = null
  },
  [ORDER_TEMPLATE_SUCCESS]: (state, { list, current } = {}) => {
    state.isLoading = false
    if (list !== undefined) state.list = list
    if (current !== undefined) state.current = current
  },
  [ORDER_TEMPLATE_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
  [VENDOR_REQUEST]: (state) => {
    state.isLoading = true
  },
  [VENDOR_SUCCESS]: (state, { vendors } = {}) => {
    state.isLoading = false
    if (vendors !== undefined) state.vendors = vendors
  },
  [VENDOR_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
  [CLIENT_USER_REQUEST]: (state) => {
    state.isLoading = true
  },
  [CLIENT_USER_SUCCESS]: (state, { clientUsers } = {}) => {
    state.isLoading = false
    if (clientUsers !== undefined) state.clientUsers = clientUsers
  },
  [CLIENT_USER_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}